import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';

const features = [
  {
    title: 'Un medico a tua disposizione H24',
    description:
      'Consulta un medico in qualsiasi momento, al telefono o in videochiamata, giorno e notte tutte le volte che ne hai bisogno, anche solo per un piccolo dubbio.',
    icon: require('../../assets/images/service-icons/medico-telefono-H24.png'),
  },
  {
    title: 'Specialisti sanitari a tariffe agevolate',
    description:
      'Accesso a prestazioni sanitarie a tariffazione agevolata presso centri diagnostici. Oltre 500 strutture convenzionate in Italia con un risparmio fino al 20% rispetto ai prezzi di listino.',
    icon: require('../../assets/images/service-icons/network-sanitario.png'),
  },
  {
    title: 'Per tutta la tua famiglia',
    description:
      "Includi fino a 3 persone oltre a te nell'abbonamento, proteggi le persone che hai a cuore.",
    icon: require('../../assets/images/service-icons/tutta-famiglia.png'),
  },
  {
    title: 'Centri odontoiatrici convenzionati',
    description:
      'Prestazioni a tariffazione agevolata presso centri odontoiatrici convenzionati con un risparmio fino al 20% rispetto ai prezzi di listino.',
    icon: require('../../assets/images/service-icons/network-odontoiatrico.png'),
  },
  {
    title: 'Alle tue prenotazioni mediche pensiamo a tutto noi',
    description:
      'I nostri operatori saranno a tua disposizione, in qualsiasi momento, per prenotare per te appuntamenti su strutture mediche e odontoiatriche convenzionate.',
    icon: require('../../assets/images/service-icons/centrale-operativa.png'),
  },
  {
    title: "Accesso all'app Doc24",
    description:
      "Monitora la tua salute in tempo reale con Doc24. Grazie ad un'innovativa tecnologia, potrai misurare i tuoi parametri vitali in soli 30 secondi tramite la videocamera del tuo smartphone!",
    icon: require('../../assets/images/service-icons/accesso-app-doc24.png'),
  },
];

const Features = () => {
  return (
    <section className="features">
      <Container>
        <h2 className="text-center mb-5">
          Abbonati a Sos Dottore, potrai beneficiare di tutti questi servizi:
        </h2>
        <Row>
          {features.map((feature, index) => (
            <Col md={4} key={index} className="mb-4">
              <Card className="feature-card h-100">
                <CardBody className="feature-card-body">
                  <div className="feature-icon">
                    <img src={feature.icon} alt={feature.title} />
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;
